module.exports = __webpack_public_path__ + "static/mockups-07a2391214a7dff6d041b0ab3d4ad5e5.jpg";